/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
import React from 'react';
import ReactDOM from 'react-dom';
import uuid from 'node-uuid';
import {Form, FormGroup, FormControl, ControlLabel} from 'react-bootstrap';
import {Glyphicon, Modal, Label, Button, Panel, ListGroup, ListGroupItem, Grid, Row, Col, Image, Checkbox} from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import ReactSpinner from 'react-spinjs';
import ActionResult from '../../stores/ActionResult';
import UserStore from '../../stores/UserStore';
import APIActions from '../../actions/apiActions';
import ProductStore from '../../stores/ProductStore';
import AppConstants from '../../constants/AppConstants';
import UIHelpers from '../../library/UIHelpers';
import PinEditModal from './PinEditModal.react';
import DataHelpers from '../../library/DataHelpers';

const DIGITAL_INPUTS_TABLE_NAME = "Digital PINs";
const ANALOGUE_INPUTS_TABLE_NAME = "Analogue inputs";
const VOLT_INPUTS_TABLE_NAME = "Volt PIN labels";


export default class ProductChannelList extends React.Component {
    constructor(props) {
        super(props);

        console.log("[ProductChannelList] - initialisation");        
        this.state = {
          dirty : false,
          displayType : 1
        };
    }

    makeEditLink(pinIndex, pinGroupName) {
      return (<a href="#" onClick={()=>this.editPin(pinIndex, pinGroupName)}><Glyphicon glyph="pencil" style={{color:"blue"}}/></a>);
    }
    makeDeleteLink(pinIndex) {
      return (<a href="#" onClick={()=>this.deletePin(pinIndex)}><Glyphicon glyph="remove" style={{color:"red"}}/></a>);
    }

    deletePin(pinIndex) {
      if (!UIHelpers.confirmAction("Are you sure you want to delete this PIN?")) {
        return ;
      }

      let p = this.props.product;
      p.pins.splice(pinIndex, 1);
      this.setState({product: p});
    }
    editPin(pinIndex, pinGroupName) {
      this.setState({editingPinState : {pin: this.props.product.pins[pinIndex], groupName: pinGroupName, existingIndex: pinIndex}});
    }

    handleViewTypeSelect(vt) {
        this.setState({displayType : vt});
    }

    makeTableOfPins(pinGroupName, shouldShowPinFunc) {
      // assemble an arry of rows
      var isAdmin = UserStore.isAdministrator();

      var product = this.props.product ;
      var rows = [];
      for (let i = 0; i < product.pins.length; ++i)
      {
        let pin = product.pins[i];
        if (pin.unused != "true" && shouldShowPinFunc(pin)) {
          let ledClass = DataHelpers.pinLedColourClass(pin);
          let ledPart = pin.type === "digital" ? <div className={ledClass} /> : <div />;
          let zeroOn = pin.type === "digital" ? <div><Checkbox validationState="success" checked={pin.zeroOn || false} /></div> : <div />;
          rows.push(<tr key={i}>
              <td>{pin.channel}</td>
              <td>{pin.type}</td>
              <td>{pin.title}</td>
              <td>{pin.desc}</td>
              <td>{pin.pinGroup || ""}</td>
              <td>{ledPart}</td>
              <td>{zeroOn}</td>
              {isAdmin ? (<td>{this.makeEditLink(i, pinGroupName)}{this.makeDeleteLink(i)}</td>) : <td></td>}
              </tr>);
        }
      }

      // Add a row containing an "add" link
      if (isAdmin) {
        rows.push(
                <tr key={-1}><td colSpan="7" style={{color:"blue"}}>
                <a href="#" onClick={()=>this.addPin(pinGroupName)}>
                <Glyphicon glyph="plus"/>{' Add'}
                </a></td></tr>);
      }

      var colHeaders = <tr><th>#</th><th>Type</th><th>Title</th><th>Description</th><th>Group</th><th>LED</th><th>Zero ON</th><th></th></tr>; 
      return (
          <div>          
            <Table striped bordered condensed hover>
            <thead>
                <tr><th colSpan="7" className="text-center">{pinGroupName}</th></tr>
                {colHeaders}
            </thead>
            <tbody>
                {rows}
            </tbody>
            </Table>      
        </div>  
        );      
    }

    render() {
        return this.makeTableOfPins("Product IO Channels", (pin) => { return true; });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/products/productChannelList.js